import type { ReadonlySignal } from "@preact/signals";
import { InputLabel } from "./input-label.js";
import { InputError } from "./input-error.js";
import { inputClass, type FieldProps } from "./shared.js";
import { autocompleteFor, enterKeyHintFor } from "../../autofill.js";
import type { FormEmbedField } from "../../types.js";

interface NumberInputProps {
  field: FormEmbedField;
  input: ReadonlySignal<any>;
  errors: ReadonlySignal<[string, ...string[]] | null>;
  props: FieldProps;
  disabled: boolean;
  isLast?: boolean;
}

export function NumberInput({ field, input, errors, props, disabled, isLast = false }: NumberInputProps) {
  const errorClass = errors.value ? "border-theme-destructive" : "border-theme-input";

  return (
    <div class={`flex flex-col gap-1 ${field.width === "half" ? "w-[calc(50%-6px)]" : "w-full"}`} data-fv-field={field.name}>
      <InputLabel label={field.label} required={field.required} description={field.description} />
      <input
        {...props}
        class={`${inputClass} ${errorClass}`}
        type="number"
        autocomplete={autocompleteFor(field)}
        enterkeyhint={enterKeyHintFor(isLast)}
        placeholder={field.placeholder || "0"}
        value={input}
        disabled={disabled}
        min={field.min}
        max={field.max}
        aria-invalid={!!errors.value}
        aria-errormessage={`${props.name}-error`}
      />
      <InputError name={props.name} errors={errors} />
    </div>
  );
}
